import { Grid, Box, Typography, styled } from "@mui/material"
import Button from "components/ui/Button"

export const Container = styled(Grid)(() => ({
  margin: "0",
}))

export const Content = styled(Box)(() => ({
  margin: "0",
  padding: "0",
}))

export const Title = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.375rem",
  },
}))

export const Description = styled(Typography)(() => ({
  textAlign: "center",
  margin: "21px 32px",
}))

export const Amount = styled(Typography)(({ theme }) => ({
  fontSize: "3.5rem",
  fontWeight: "400",
  height: "1.4375em",
  lineHeight: "1.4375em",
  margin: "0",
  padding: "0",
  textAlign: "center",
  [theme.breakpoints.down("lg")]: {},
}))

export const Pay = styled(Button)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.common.white,
  borderRadius: "21px",
  fontSize: "0.875rem",
  textTransform: "inherit",
  height: "44px",
  margin: "24px auto 0 auto",
  padding: "0 20px",
  width: "226px",
  [theme.breakpoints.down("md")]: {},
}))

export const Terms = styled(Box)(({ theme }) => ({
  display: "block",
  margin: "12px 0 0 0",
  overflow: "hidden",
  textAlign: "center",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    marginTop: "10px",
  },
}))

export const Wrapper = styled(Box)(() => ({
  margin: "0 auto",
  padding: "0",
  maxWidth: "50%",
}))

export const Submit = styled(Button)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.common.white,
  borderRadius: "21px",
  fontSize: "0.875rem",
  textTransform: "inherit",
  height: "44px",
  margin: "24px auto 0 auto",
  padding: "0 20px",
  width: "226px",
  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
    margin: "8px 0",
    width: "100%",
  },
}))
